﻿export const DEFAULT_WMS_FORMAT = 'image/png';
export const DEFAULT_WFS_FORMAT = 'application/json';
export const WKT = 'WKT';